import { Theme } from 'config';

const styles = (theme: Theme) => ({
  grid: {
    position: 'relative',
    margin: '0 !important',
    width: '100% !important',
  },
  container: {
    width: '100% !important',
    justifyContent: 'center',
    padding: '.625rem 1.25rem !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05)',
    borderRadius: '.25rem',
    backgroundColor: '#fff',
  },
  loading: {
    '&&': {
      width: '100% !important',
    },
  },
  headerContainer: {
    margin: '1rem 1rem 1.75rem 1.25rem !important',
    width: '40%',
  },
  header: {
    fontSize: '1.375rem',
    color: `${theme.violet} !important`,
  },
  headerText: {
    fontSize: '.9375rem',
    color: `${theme.darkGray}`,
  },
  map: {
    borderRadius: '.25rem',
    padding: '0 !important',
    height: '40.625rem',
    overflow: 'hidden',
  },
  onboardingMsg: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    color: `${theme.darkGray}`,
    margin: '.5rem !important',
    '& p': {
      margin: '.25rem .5rem !important',
    },
  },
  onboardingMsgTitle: {
    color: `${theme.deepPurple}`,
  },
});

export default styles;
